import template from './visualPicker.html';
import './visualPicker.less';
import VisualPickerController from './visualPicker.controller';

const VisualPickerComponent = {
  bindings: {
    parentSolution: '<',
    formData: '<',
    parentsWithCheckedChildren: '<',
    description: '<',
    setInvalidClass: '<',
  },
  template,
  controller: VisualPickerController
};

export default VisualPickerComponent;




// WEBPACK FOOTER //
// ./src/components/search-form/visual-picker/visualPicker.component.js